(() => {
  const ready = (root, key = 'lvReady') => {
    if (root.dataset[key] === 'true') return false;
    root.dataset[key] = 'true';
    return true;
  };

  const initProductHero = (root) => {
    if (!ready(root, 'lvProductReady')) return;

    const gallery = root.querySelector('[data-lv-gallery]');
    if (gallery) {
      const slides = [...gallery.querySelectorAll('[data-lv-gallery-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-lv-gallery-thumb]')];
      const previous = gallery.querySelector('[data-lv-gallery-prev]');
      const next = gallery.querySelector('[data-lv-gallery-next]');
      const counter = gallery.querySelector('[data-lv-gallery-counter]');
      const stage = gallery.querySelector('.lv-product-gallery__stage');
      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let touchStartX = null;

      const showSlide = (index, focusThumb = false) => {
        if (!slides.length) return;
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
        });
        thumbs.forEach((thumb, i) => {
          const active = i === activeIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        const activeThumb = thumbs[activeIndex];
        activeThumb?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        if (focusThumb) activeThumb?.focus({ preventScroll: true });
        if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      };

      thumbs.forEach((button, index) => button.addEventListener('click', () => showSlide(index)));
      previous?.addEventListener('click', () => showSlide(activeIndex - 1));
      next?.addEventListener('click', () => showSlide(activeIndex + 1));
      stage?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); showSlide(activeIndex - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); showSlide(activeIndex + 1); }
      });
      stage?.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches?.[0]?.clientX ?? null;
      }, { passive: true });
      stage?.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const endX = event.changedTouches?.[0]?.clientX ?? touchStartX;
        const delta = endX - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) < 42) return;
        showSlide(activeIndex + (delta < 0 ? 1 : -1));
      }, { passive: true });
      if (stage) stage.setAttribute('tabindex', '0');
      showSlide(activeIndex);
    }

    const quantityInput = root.querySelector('[data-lv-form-quantity]');
    root.querySelectorAll('input[name="lv_quantity"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        if (quantityInput) quantityInput.value = radio.value;
        root.querySelectorAll('.lv-quantity-card').forEach((card) => {
          card.classList.toggle('is-selected', Boolean(card.querySelector('input:checked')));
        });
      });
    });

    const variantSelect = root.querySelector('[data-lv-variant-select]');
    const updateVariant = () => {
      if (!variantSelect) return;
      const option = variantSelect.selectedOptions[0];
      if (!option) return;
      const available = option.dataset.available === 'true';
      const price = option.dataset.price || '';
      const compare = option.dataset.compare || '';
      const saving = Number(option.dataset.saving || 0);

      root.querySelectorAll('[data-lv-current-price], [data-lv-unit-price], [data-lv-sticky-price]').forEach((element) => {
        element.textContent = price;
      });
      root.querySelectorAll('[data-lv-double-price]').forEach((element) => {
        element.textContent = option.dataset.double || price;
      });

      const compareElement = root.querySelector('[data-lv-compare-price]');
      if (compareElement) {
        compareElement.textContent = compare;
        compareElement.hidden = !compare;
      }
      root.querySelectorAll('[data-lv-unit-compare]').forEach((element) => {
        element.textContent = compare;
        element.hidden = !compare;
      });
      root.querySelectorAll('[data-lv-double-compare]').forEach((element) => {
        const doubleCompare = option.dataset.doubleCompare || '';
        element.textContent = doubleCompare;
        element.hidden = !doubleCompare;
      });
      const savingElement = root.querySelector('[data-lv-saving]');
      if (savingElement) {
        savingElement.textContent = saving > 0 ? `${root.dataset.lvSavingCopy || 'Ahorra'} ${saving}%` : '';
        savingElement.hidden = saving <= 0;
      }

      const button = root.querySelector('[data-lv-atc]');
      if (button) button.disabled = !available;
      root.querySelectorAll('[data-lv-atc-label], [data-lv-sticky-label]').forEach((label) => {
        label.textContent = available ? (root.dataset.lvAtcCopy || 'Añadir al carrito') : (root.dataset.lvSoldOutCopy || 'Agotado');
        if (label.matches('button')) label.disabled = !available;
      });
    };
    variantSelect?.addEventListener('change', updateVariant);
    updateVariant();

    const form = root.querySelector('.lv-product-form');
    const mainAtc = root.querySelector('[data-lv-atc]');
    const sticky = root.querySelector('[data-lv-sticky-atc]');
    const stickyButton = root.querySelector('[data-lv-sticky-submit]');

    stickyButton?.addEventListener('click', () => {
      if (!form || !mainAtc || mainAtc.disabled) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(mainAtc);
      else mainAtc.click();
    });

    if (mainAtc && sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const passedMainAtc = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passedMainAtc);
        sticky.setAttribute('aria-hidden', passedMainAtc ? 'false' : 'true');
      }, { threshold: [0, .01, 1] });
      observer.observe(mainAtc);
    }
  };

  const refreshCartDrawer = async (drawer, addResponse) => {
    if (drawer && typeof drawer.renderContents === 'function' && addResponse?.sections) {
      drawer.renderContents(addResponse);
      if (typeof drawer.open === 'function') window.setTimeout(() => drawer.open(), 60);
      return;
    }

    const cartUrl = window.routes?.cart_url || '/cart';
    const response = await fetch(`${cartUrl}?section_id=cart-drawer`, {
      headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Cart drawer could not be refreshed.');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming = doc.querySelector('cart-drawer');
    let activeDrawer = drawer || document.querySelector('cart-drawer');

    if (incoming && activeDrawer) {
      activeDrawer.innerHTML = incoming.innerHTML;
      activeDrawer.className = incoming.className;
    } else if (incoming && !activeDrawer) {
      document.body.appendChild(incoming);
      activeDrawer = document.querySelector('cart-drawer');
    }

    activeDrawer = activeDrawer || document.querySelector('cart-drawer');
    activeDrawer?.classList.remove('is-empty');
    if (activeDrawer && typeof activeDrawer.open === 'function') activeDrawer.open();
    else if (activeDrawer) {
      activeDrawer.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
  };

  const initAjaxCartForm = (form) => {
    if (!ready(form, 'lvAjaxCartReady')) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.dataset.lvSubmitting === 'true') return;

      const submitter = event.submitter || form.querySelector('button[type="submit"], [name="add"]');
      if (submitter?.disabled) return;

      const originalLabel = submitter?.querySelector('[data-lv-atc-label]')?.textContent || submitter?.textContent || '';
      form.dataset.lvSubmitting = 'true';
      if (submitter) {
        submitter.disabled = true;
        submitter.setAttribute('aria-busy', 'true');
      }

      try {
        const drawer = document.querySelector('cart-drawer');
        const formData = new FormData(form);
        formData.delete('lv_quantity');

        let sectionIds = ['cart-drawer'];
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          const sections = drawer.getSectionsToRender();
          if (Array.isArray(sections) && sections.length) sectionIds = sections.map((section) => section.id);
        }
        formData.set('sections', sectionIds.join(','));
        formData.set('sections_url', window.location.pathname);

        const addUrl = window.routes?.cart_add_url || '/cart/add.js';
        const response = await fetch(addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'No se ha podido añadir el producto al carrito.');

        await refreshCartDrawer(drawer, data);
        document.dispatchEvent(new CustomEvent('neolimpio:cart-added', { detail: data }));
      } catch (error) {
        console.error('[Neolimpio cart]', error);
        const label = submitter?.querySelector('[data-lv-atc-label]');
        if (label) {
          label.textContent = 'Inténtalo de nuevo';
          window.setTimeout(() => { label.textContent = form.closest('[data-lv-product-hero]')?.dataset.lvAtcCopy || originalLabel || 'Añadir al carrito'; }, 1600);
        }
      } finally {
        form.dataset.lvSubmitting = 'false';
        if (submitter) {
          submitter.removeAttribute('aria-busy');
          const variantSelect = form.closest('[data-lv-product-hero]')?.querySelector('[data-lv-variant-select]');
          const available = variantSelect ? variantSelect.selectedOptions[0]?.dataset.available === 'true' : true;
          submitter.disabled = !available;
        }
      }
    });
  };

  const initSlider = (track) => {
    const shell = track.parentElement;
    if (!shell || !ready(shell, 'lvSliderReady')) return;
    const previous = shell.querySelector('[data-lv-slider-prev]');
    const next = shell.querySelector('[data-lv-slider-next]');
    const amount = () => Math.max(220, track.clientWidth * .72);
    const update = () => {
      if (previous) previous.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    previous?.addEventListener('click', () => track.scrollBy({ left: -amount(), behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left: amount(), behavior: 'smooth' }));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const initCountdown = (root) => {
    if (!ready(root, 'lvCountdownReady')) return;
    const target = Date.parse(root.dataset.end || '');
    const value = root.querySelector('[data-lv-countdown-value]');
    if (!value || Number.isNaN(target)) return;
    const tick = () => {
      const difference = target - Date.now();
      if (difference <= 0) {
        value.textContent = root.dataset.expired || 'Oferta finalizada';
        return;
      }
      const days = Math.floor(difference / 86400000);
      const hours = Math.floor((difference % 86400000) / 3600000);
      const minutes = Math.floor((difference % 3600000) / 60000);
      const seconds = Math.floor((difference % 60000) / 1000);
      value.textContent = `${days ? `${days}d ` : ''}${String(hours).padStart(2,'0')}:${String(minutes).padStart(2,'0')}:${String(seconds).padStart(2,'0')}`;
      window.setTimeout(tick, 1000);
    };
    tick();
  };

  const initDetails = (details) => {
    if (!ready(details, 'lvDetailsReady')) return;
    const summary = details.querySelector(':scope > summary');
    if (!summary) return;
    const update = () => summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    details.addEventListener('toggle', update);
    update();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-lv-product-hero]').forEach(initProductHero);
    scope.querySelectorAll('.lv-product-form[action*="/cart/add"]').forEach(initAjaxCartForm);
    scope.querySelectorAll('[data-lv-slider-track]').forEach(initSlider);
    scope.querySelectorAll('[data-lv-countdown]').forEach(initCountdown);
    scope.querySelectorAll('.lv-accordion, .lv-faq').forEach(initDetails);
    scope.querySelectorAll('[data-lv-scroll-buybox]').forEach((trigger) => {
      if (!ready(trigger, 'lvScrollReady')) return;
      trigger.addEventListener('click', (event) => {
        const target = document.querySelector('.lv-product-buybox, .lv-home-product');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
